"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _orderEntryFormConstants = require("../../../constants/sendOrder/orderEntryFormConstants");
var _reactRedux = require("react-redux");
var _instrumentPositionSelectors = require("../../../redux/selectors/instrumentPositionSelectors");
var _orderEntrySelector = require("../../../redux/selectors/orderEntrySelector");
var _numberFormatter = require("../../../helpers/numberFormatter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var selectorArgs = {
  formName: 'advancedOrderEntry'
};
var AdvancedOrderMarketPrice = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var baseClass = _ref.baseClass;
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var instrument = (0, _reactRedux.useSelector)(_instrumentPositionSelectors.selectedInstrumentSelector);
  var side = (0, _reactRedux.useSelector)(function (state) {
    return (0, _orderEntrySelector.selectOrderFormValues)(state, selectorArgs).side;
  });
  var marketPrice = (0, _reactRedux.useSelector)(function (state) {
    return (0, _orderEntrySelector.selectMarketPrice)(state, selectorArgs);
  });
  var formattedMarketPrice = (0, _numberFormatter.formatNumberToLocale)(marketPrice, instrument.Product2Symbol);
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)([baseClass]);
  var priceTitle = side === _orderEntryFormConstants.sellValue ? t('Bid Price') : t('Ask Price ');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('limit-price-block')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('limit-price-block-label')
  }, "".concat(priceTitle, " ").concat(instrument.Product1Symbol, " (").concat(instrument.Product2Symbol, ")")), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('limit-price-block-value')
  }, formattedMarketPrice));
});
AdvancedOrderMarketPrice.displayName = 'AdvancedOrderMarketPrice';
AdvancedOrderMarketPrice.propTypes = {
  baseClass: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = AdvancedOrderMarketPrice;